import { Button, Card, Col, Flex, Image, Input, Modal, Row } from "antd";
import SMSIcon from "../../../assets/images/sms.svg"
import useWepapp from "./useWepapp";
import { useEffect, useRef, useState } from "react";
import ResendIcon from "../../../assets/images/reSend.svg"
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import { setIsLoading } from "../slices/webappSlice";
import { useDispatch, useSelector } from "react-redux";
import { getCreateRequestLoan, getVerifyOtp } from "../services/webAppApi";
import { generateRandomString } from "utils/helper";

const useOtp = () => {
    const isPortrait = useMediaQuery({ orientation: 'portrait' })
    const [initialVisit, setInitialVisit] = useState(true);
    const [seconds, setSeconds] = useState(60);
    const [isCountingDown, setIsCountingDown] = useState(true);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const { isLoading, profile } = useSelector((state) => state.webapp);
    useEffect(() => {
        const initialTimer = setTimeout(() => {
            setInitialVisit(false);
        }, 3000); // Adjust the duration as needed

        return () => clearTimeout(initialTimer);
    }, []);

    useEffect(() => {
        if (isCountingDown && seconds > 0) {
            const timerId = setTimeout(() => setSeconds(seconds - 1), 1000);
            return () => clearTimeout(timerId);
        }
    }, [isCountingDown, seconds]);

    const handleResendClick = () => {
        setSeconds(60);
        setIsCountingDown(true);
    };

    const serviceCreateRequestLoan = async (params) => {
        try {
            dispatch(setIsLoading(true));
            const response = await getCreateRequestLoan({
                ...params,
                requestId: generateRandomString(),
                creditUsage: location?.state?.creditUsage,
                productCode: "BE0001"
            });
            navigate("/webapp/detail", { state: { txnId: response?.data?.content } })
        } catch (error) {
            console.log("error", error);
            Modal.error({ content: error?.data?.status?.description })
        } finally {
            dispatch(setIsLoading(false));
        }
    }
    const serviceVerify = async (params, cb = () => { }) => {
        try {
            dispatch(setIsLoading(true));
            console.log("inputRefs", inputRefs);

            const response = await getVerifyOtp({
                ...params,
                refNo: location?.state?.refNo,
                otp: inputRefs?.current?.map?.(o => o?.input?.value)?.join?.("")
            });
            cb()
        } catch (error) {
            console.log("error", error);
            Modal.error({ content: error?.data?.status?.description })
        } finally {
            dispatch(setIsLoading(false));
        }
    }

    const handleConfirm = async () => {

        serviceVerify(null, serviceCreateRequestLoan)
    }

    function otpHeader() {
        return (
            <Flex vertical style={{ rowGap: "2vh" }}>
                <Image
                    preview={false}
                    src={SMSIcon}
                    height={"7vh"}
                />
                <Flex vertical style={{ alignItems: "center", color: "#909090" }}>
                    <span>กรุณากรอก OTP ที่ได้รับทาง</span>
                    <span>เบอร์โทรศัพท์ {profile?.mobileNumber?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")} ของท่าน</span>
                    <span style={{ fontSize: isPortrait ? "2vh" : "2.5vh" }}>รหัสอ้างอิง : {location?.state?.refNo}</span>
                </Flex>
            </Flex>
        )
    }
    const inputRefs = useRef([]);

    const setInputOtp = (e, index) => {
        const value = e.target.value;
        if (value.length === 1 && index < 5) {
            // Move to next input
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !e.target.value && index > 0) {
            // Move to previous input
            inputRefs.current[index - 1].focus();
        }
    };
    function otpInput() {
        return (
            <>
                <Row gutter={6} justify={"center"}>
                    {[...Array(6)].map((_, i) => (
                        <Col span={4} key={i}>
                            <Input
                                id={`number_${i + 1}`}
                                type="number"
                                pattern="[0-9]*"
                                inputMode="numeric"
                                maxLength={1}
                                style={{ width: "fit-content" }}
                                onChange={(e) => setInputOtp(e, i)}
                                onKeyDown={(e) => handleKeyDown(e, i)}
                                ref={(el) => inputRefs.current[i] = el}
                            />
                        </Col>
                    ))}
                </Row>
                <Flex vertical style={{ alignItems: "center", fontSize: isPortrait ? "2vh" : "3vh" }}>
                    {initialVisit ? (
                        <span style={{ color: "#bbbbbb" }}>ขอรับรหัส OTP</span>
                    ) : (
                        <>
                            <span style={{ color: "#bbbbbb" }}>หากไม่ได้รับรหัส OTP</span>
                            {seconds > 0 ? (
                                <span style={{ color: "#FF9401" }}>
                                    ส่งใหม่อีกครั้งภายใน {seconds} วินาที
                                </span>
                            ) : (
                                <Row style={{ gap: "1vh" }}>
                                    <span
                                        style={{ color: "#bbbbbb", cursor: "pointer" }}
                                        onClick={handleResendClick}
                                    >
                                        ส่งใหม่อีกครั้ง
                                    </span>
                                    <span>
                                        <Image preview={false} src={ResendIcon} />
                                    </span>
                                </Row>
                            )}
                        </>
                    )}
                </Flex>
            </>
        )
    }

    function otpFooter() {
        return (
            <Card style={{
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                width: "100%",
                height: "11vh",
                position: "fixed",
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}>
                <Flex style={{ justifyContent: "center", width: "100%" }}>
                    <Button onClick={() => handleConfirm()} style={{
                        borderRadius: "4vh",
                        backgroundColor: "#FF9401",
                        borderColor: "#FF9401",
                        width: isPortrait ? "30vh" : "25vw",
                        height: isPortrait ? "5vh" : "7vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <span style={{ color: "white", fontSize: isPortrait ? "2vh" : "1.9vw", }}>ยืนยัน</span>
                    </Button>
                </Flex>
            </Card>
        )
    }

    return {
        otpHeader,
        otpInput,
        otpFooter
    }
}
export default useOtp;